import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Signout } from '../Signout/Signout';
import { BorrarUser } from '../BorrarUser/BorrarUser';
import { ModalCarga } from '../ModalCarga/ModalCarga';
import './Usuario.css';
import { goStripePortal } from '../../firebase/portal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBell,
  faStar,
  faUser,
  faAngleDown,
  faAngleUp,
  faCrown,
  faCoins,
  faCircleInfo,
  faGear
} from '@fortawesome/free-solid-svg-icons';
import { useAuth } from '../../context/AuthContext';
import { ConfiguracionCuentaModal } from './ConfiguracionCuentaModal/ConfiguracionCuentaModal'; // ⬅ nuevo import

export const Usuario = () => {
  const navigate = useNavigate();
  const { user, loading: authLoading, premium, planName } = useAuth();
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [showConfigModal, setShowConfigModal] = useState(false); // ⬅ nuevo estado

  const toggleDropdown = () => setIsOpen(!isOpen);
  const toggleConfigModal = () => setShowConfigModal(!showConfigModal); // ⬅ nuevo manejador

  const goToFavoritos = () => navigate('/favoritos');
  const goToAlertas = () => navigate('/alertas');
  const goToPremium = () => navigate('/premium');
  const goToAffiliateDashboard = () => navigate('/afiliados-dashboard');

  const goStripePortalWithLoading = async () => {
    try {
      setLoading(true);
      await goStripePortal();
    } catch (error) {
      console.error('Error al ir al portal de Stripe:', error);
      alert('Ocurrió un error durante el proceso. Por favor, inténtalo de nuevo.');
    } finally {
      setLoading(false);
    }
  };

  if (authLoading || !user) return <ModalCarga />;

  return (
    <div>
      {loading && <ModalCarga />}
      {showConfigModal && <ConfiguracionCuentaModal user={user} onClose={toggleConfigModal} />} {/* ⬅ modal */}
      
      <div className="usuario">
        <div className="info-y-botones">
          <div className="info-user">
            <div className="user-plan">
              <h1>{user.displayName}</h1>
              <span className="premium-label">{premium ? planName : 'Gratis'}</span>
            </div>
            <p className="puser">{user.email}</p>
            <p className="puser">{user.username}</p>
          </div>

          <div className="servicios-premium user-h2">
            <h2>Servicios</h2>
            <ul>
              {!premium ? (
                <>
                  <li>
                    <p className="puser">¡Activa tu primera alerta gratis y deja que eRastro busque por ti!</p>
                  </li>
                  <li>
                    <button className="go-premium" onClick={goToAlertas}>
                      <p><FontAwesomeIcon icon={faBell} /> Mis Alertas</p>
                    </button>
                  </li>
                  <li>
                    <p className="puser">¿Quieres más alertas y funciones avanzadas?</p>
                  </li>
                  <li>
                    <button className="suscribe-premium" onClick={goToPremium}>
                      <p><FontAwesomeIcon icon={faCrown} /> Hazte Premium</p>
                    </button>
                  </li>
                  <li>
                    <button className="go-premium" onClick={goToPremium}>
                      <p><FontAwesomeIcon icon={faStar} /> Rastreador de Productos</p>
                    </button>
                  </li>
                </>
              ) : (
                <>
                  <li>
                    <button onClick={goToAlertas}>
                      <p><FontAwesomeIcon icon={faBell} /> Mis Alertas</p>
                    </button>
                  </li>
                  <li>
                    <button onClick={goToFavoritos}>
                      <p><FontAwesomeIcon icon={faStar} /> Rastreador de Productos</p>
                    </button>
                  </li>
                </>
              )}
            </ul>
          </div>

          <div className="botones-user user-h2">
            <h2 onClick={toggleDropdown} className="dropdown-toggle">
              Gestionar Cuenta
              <span>{isOpen ? <FontAwesomeIcon icon={faAngleUp} /> : <FontAwesomeIcon icon={faAngleDown} />}</span>
            </h2>

            {isOpen && (
              <ul className="dropdown-list">
                {/* Nuevo botón Configuración */}
                <li>
                  <button onClick={toggleConfigModal}>
                    <p>
                      <FontAwesomeIcon icon={faGear} /> Configuración de cuenta
                    </p>
                  </button>
                </li>

                {user.affiliate && (
                  <li>
                    <button onClick={goToAffiliateDashboard}>
                      <p><FontAwesomeIcon icon={faCoins} /> Gestionar Afiliados</p>
                    </button>
                  </li>
                )}

                {premium && (
                  <li>
                    <button onClick={goStripePortalWithLoading} disabled={loading} className="manage-button">
                      <p style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                        <FontAwesomeIcon icon={faUser} />
                        Gestionar suscripción
                        <span className="info-container">
                          <span className="info-icon">
                            <FontAwesomeIcon icon={faCircleInfo} />
                          </span>
                          <div className="info-tooltip">
                            Cancelar suscripción<br />
                            Cambiar de plan<br />
                            Ver historial de facturas
                          </div>
                        </span>
                      </p>
                    </button>
                  </li>
                )}

                <li><BorrarUser usuario={user} /></li>
              </ul>
            )}
          </div>

          <Signout />
        </div>
        <img className="img-perfil" src="/imgs/perfil.jpg" alt="persona con bolsa para comprar" />
      </div>
    </div>
  );
};
